import { Input } from 'design-system';

import { useAppForm } from '@/features/dashboard/components/AppForm/AppForm/context';

const MIN_YEARS = 1;
const MAX_YEARS = 25;
export const DEFAULT_SEASONAL_YEARS = '3';

export const SelectSeasonalRange = () => {
  const { form } = useAppForm();
  return (
    <form.Field
      children={field => (
        <section className='flex w-full flex-col gap-2 rounded-xl bg-card p-4'>
          <h3 className='text-sm font-semibold'>Time range</h3>
          <p className='mb-2 text-xs font-medium text-muted-foreground'>
            Select the number of years to show in the chart
          </p>
          <Input
            id='seasonalPeriodSelect'
            className='w-[100px]'
            max={MAX_YEARS}
            min={MIN_YEARS}
            onChange={e => {
              const raw = Number.parseInt(e.target.value, 10);
              if (!Number.isNaN(raw)) {
                field.handleChange(String(Math.min(MAX_YEARS, Math.max(MIN_YEARS, raw))));
              }
            }}
            type='number'
            value={field.state.value}
          />
        </section>
      )}
      name='from'
    />
  );
};
